import { Component } from "@angular/core";
import { Validateable } from "@models/interfaces";
import { VerificationOnfidoFailedComponent } from "../verification-onfido-failed/verification-onfido-failed.component";
import { ModalService } from "@core-services/modal.service";
import { OnfidoService } from "../../services/onfido.service";
import { SocketService } from "@main-services/socket.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: "onfido",
	templateUrl: "./onfido.component.html",
	styleUrls: ["./onfido.component.scss"],
	standalone: false
})
export class OnfidoComponent {
	public constructor(
		private onfidoService: OnfidoService,
		private socketService: SocketService,
		private modalService: ModalService
	) {
		// Subscribe to socket event in order to display desktop notification
		this.socketService
			// TODO: eslint fix
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			.joinRoom<any>({
				name: "onfido",
				type: Validateable,
				isPrivate: true
			})
			.pipe(untilDestroyed(this))
			.subscribe((res) => {
				if (res["internal_failure_reason"]) {
					this.modalService
						.create(VerificationOnfidoFailedComponent, {
							reason: res["internal_failure_reason"]
						})
						.present();
				}
			});
	}

	public initOnfido(): void {
		this.onfidoService.initOnfido();
	}

	public getContainerId(): string {
		return this.onfidoService.getContainerId();
	}
}
